import { atomWithReset } from "jotai/utils";

import type { OrderDetail, OrderListItem } from "../types";

export const orderDetailModalAtom = atomWithReset<{
  visible: boolean;
  data: OrderDetail | OrderListItem | null;
}>({
  visible: false,
  data: null
});
